export function formatPrice(priceInCents: number) {
  const isWholeDollar = priceInCents % 100 === 0;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: isWholeDollar ? 0 : 2,
    maximumFractionDigits: isWholeDollar ? 0 : 2,
  }).format(priceInCents / 100);
}
